/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import { RightSide } from '../right-side/right-side-components';
import { ThanksRS } from '../right-side/right-side-components';

export const rightRoutes = [{
  path: '/',
  component: RightSide,
},
{
  path: '/signup/',
  component: RightSide,
},
{
  path: '/signup/:type',
  component: RightSide,
},
{
  path: '/forgot-password',
  component: RightSide,
},
{
  path: '/reset-password/:tmp',
  component: RightSide,
},
{
  path: '/maintenance',
  component: RightSide,
},
{
  path: '/thanks',
  component: ThanksRS,
}];

export default rightRoutes;